import claimsSaga from "./claims/claimsSaga";
import hazardProfileSaga from "./exposures/hazardProfileSaga";
import glRatingLimitsSaga from "./flags/glRatingLimitsSaga";
import programSaga from "./program/programSaga";
import { spawn } from "redux-saga/effects";

export default function* inputSaga() {
  yield spawn(claimsSaga);
  yield spawn(hazardProfileSaga);
  yield spawn(glRatingLimitsSaga);
  yield spawn(programSaga);
}
